// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".input-error {\r\n    border: 1px solid red !important;\r\n    border-radius: 4px;\r\n}\r\n", "",{"version":3,"sources":["webpack://./Client/source/cough/WeeklyQA.css"],"names":[],"mappings":"AAAA;IACI,gCAAgC;IAChC,kBAAkB;AACtB","sourcesContent":[".input-error {\r\n    border: 1px solid red !important;\r\n    border-radius: 4px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
